import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPageInitialContent,
  defaultPageProperties,
  defaultPageValidations,
  defaultPropertiesGroups,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("ErrorPage", {
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  initialContent: { ...defaultPageInitialContent, ...metadataInitialContent },
  properties: [...defaultPageProperties, "redirectButton", "backButton"],
  propertiesGroups: [...defaultPropertiesGroups, ...metadataPropertiesGroups],
  validations: [...defaultPageValidations, ...metadataValidations],
});
